import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, className = "", delay = 0, y = 28, as = "div", once = true, ...rest }) => {
  const reduce = useReducedMotion();
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-8% 0px" }}
      transition={{ duration: 0.55, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

// Masked line-by-line headline reveal.
// pt-[0.15em] on each mask keeps tall marks (e.g. the hamza on an initial أ/إ) from being clipped
// by overflow-hidden; -mt-[0.15em] on the outer span cancels that offset so the first line still
// sits where it did before (only the gap between stacked lines grows, by the same 0.15em).
export const Lines = ({ lines, className = "", lineClass = "", delay = 0, stagger = 0.09 }) => {
  const reduce = useReducedMotion();
  return (
    <span className={`-mt-[0.15em] ${className}`}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.06em] pt-[0.15em]">
          <motion.span
            className={`block ${lineClass}`}
            initial={reduce ? false : { y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.8, ease: EASE, delay: delay + i * stagger }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

// Badge "stamp" thump on viewport entry
export const Stamp = ({ children, className = "", delay = 0 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { scale: 1.08, opacity: 0 }}
      whileInView={{ scale: 1, opacity: 1 }}
      viewport={{ once: true, margin: "-10% 0px" }}
      transition={{ duration: 0.45, ease: [0.34, 1.2, 0.64, 1], delay }}
    >
      {children}
    </motion.div>
  );
};

export { EASE };
